
<link rel='stylesheet prefetch' href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.6.2/css/font-awesome.min.css'>

<div class="">
  <div class="mb-video-large">
    <div class="mb-video-outer">
      <div id="you-video-wrapper" class="mb-video-wrapper">
        <div id="you-video"></div>
      </div>
      <div class="video-session-status-wrap" *ngIf="isOtherUserConnected">
        <div class="video-session-status"><div class="status-connected"></div></div>
        <div class="video-session-status">CONNECTED</div>
      </div>
      <div class="mb-video-small">
        <div id="me-video" class="mb-video-wrapper-small">
        </div>
      </div>
      <div class="mb-video-control-wrapper">
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 mb-video-control">
          <button type="button" [className]="isVideoPaused ? 'mb-video-control-on' : 'mb-video-control-off'" (click)="toggleVideo()"></button>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 mb-video-control">
          <button type="button" [className]="isMuted ? 'mb-video-control-unmute' : 'mb-video-control-mute'" (click)="toggleMute()"></button>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 mb-video-control"><button type="button" class="mb-video-control-stop" (click)="endSession()" ></button></div>
      </div>
    </div>
  </div>
</div>
